<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../EventBus.js'

export default {
  name: 'campaign',
  components: {
    Field,
  },
  props: {
    participants: {
      type: Array,
      required: false,
      default: [],
    },
    minStep: {
      type: Number,
      required: false,
      default: 1,
    },
    maxStep: {
      type: Number,
      required: false,
      default: 3,
    },
    topic: {
      type: String,
      required: false,
      default: '',
    },
    price: {
      type: Number,
      required: false,
      default: 0,
    },
    id: {
      type: String,
      required: true,
      default: 'campaign',
    },
  },
  data() {
    return {
      currentStep: 1,
      selected: [],
      requiredConfirm: false,
      confirmed: false,
    }
  },
  mounted() {
    EventBus.$emit('init-campaign', {
      id: this.id,
      price: this.price,
      topic: this.topic,
    })
  },
  computed: {
    selectedParticipants() {
      return map(this.selected, (participantIdx) => {
        return this.participants[participantIdx]
      })
    },
    campaignData() {
      return find(get(this, '$parent.campaignField.data'), {info: {id: this.id}}) || {}
    },
    completed() {
      return !(this.requiredConfirm && !this.confirmed)
    },
  },
  methods: {
    next() {
      this.requiredConfirm = true
      if(this.currentStep < this.maxStep) this.currentStep += 1
    },
    confirm() {
      this.confirmed = true
      this.next()
    },
    previous() {
      if(this.currentStep > this.minStep) this.currentStep -= 1
      if (this.currentStep === 1) {
        this.resetSelected()
      }
    },
    revise() {
      this.confirmed = false
      this.previous()
    },
    resetSelected() {
      this.selected = []
      this.confirmed = false
      this.requiredConfirm = false
      this.$refs.participants.inputValueArr = []
      setTimeout(() => {
        this.$refs.timeslot.inputValue = false
      }, 10)
    },
    updateCampaignParticipant(value) {
      this.selected = value
    },
    cancel() {
      this.requiredConfirm = false
      this.currentStep = 1
      this.resetSelected()
    },
  },
  watch: {
    completed(value) {
      console.log('completed watch ._.')
      EventBus.$emit('update-campaign-field', this.id, 'confirmed', value)
    }
  }
}
</script>
